module.exports = __webpack_public_path__ + "img/syukyaku-sytem-ira003.32028e0f.png";